import LockIcon from '@jetbrains/icons/lock.svg'
import Avatar, {Size as AvatarSize} from '@jetbrains/ring-ui/components/avatar/avatar'
import fuzzyHighlight from '@jetbrains/ring-ui/components/global/fuzzy-highlight'
import {Fragment} from 'react'

import Highlight from '../../../../../../../../common/Highlight/Highlight'
import {getRepositoryDetailsItemFromUrl} from '../../../../../../CreatePipelinePage/Repositories/RepositoryList/useOutsideRepository.utils'
import GitHubIcon from '../../../../../../svg/github.svg'
import type {
  PipelineRepository,
  RepositoryDetailsSelectItem,
  RepositorySelectItem,
} from '../../PipelineRepositories.types'

import styles from './PipelineRepositoryAutocomplete.css'

const repositoryClientIcons: Record<string, string> = {
  ['github.com']: GitHubIcon,
}

export const getRepositoryIcon = (repository?: string) => {
  try {
    if (repository) {
      const {host} = new URL(repository)
      const repositoryIcon = repositoryClientIcons[host]

      if (repositoryIcon) {
        return repositoryIcon
      }
    }
  } catch (e) {
    return null
  }
  return null
}

const getRepositoryItem = ({
  login,
  avatarUrl,
  repositoryName,
  repositoryUrl,
  defaultBranch,
  isPrivate,
  searchValue,
}: RepositoryDetailsSelectItem): RepositorySelectItem => {
  const label = `${login}/${repositoryName}`
  const matches = fuzzyHighlight(searchValue, label).matches

  return {
    key: repositoryUrl,
    name: repositoryName,
    login,
    title: label,
    className: styles.autocompleteButton,
    defaultBranch,
    htmlUrl: repositoryUrl,
    isPrivate,
    leftNodes: (
      <Avatar
        className={styles.avaterImg}
        size={AvatarSize.Size20}
        alt={login}
        title={login}
        url={avatarUrl}
        username={login}
      />
    ),
    label: (
      <div className={styles.autocompleteItem}>
        <Highlight string={label} matches={matches} />
        {isPrivate && (
          <Fragment>
            <span className={styles.privateRepoIcon}>
              <LockIcon />
            </span>
            <span className={styles.privateRepo}>{'Private'}</span>
          </Fragment>
        )}
      </div>
    ),
  }
}

export const getRepositorieAutocompleteOptions = (
  searchValue: string,
  repositories: PipelineRepository[],
  isRepositoryTestConnection: boolean,
) => {
  const repositorieAutocompleteList = repositories.map(
    ({name, login, isPrivate, avatarUrl, defaultBranch, htmlUrl}) =>
      getRepositoryItem({
        repositoryName: name,
        repositoryUrl: htmlUrl,
        login,
        isPrivate,
        avatarUrl,
        defaultBranch,
        searchValue,
      }),
  )

  if (isRepositoryTestConnection) {
    const repositoryDetailsItem = getRepositoryDetailsItemFromUrl(searchValue)

    if (repositoryDetailsItem) {
      const repositoryItem = getRepositoryItem({
        searchValue,
        repositoryUrl: searchValue,
        isPrivate: false,
        ...repositoryDetailsItem,
      })
      const isRepositoryExist = repositorieAutocompleteList.find(
        ({title}) => title === repositoryItem.title,
      )

      if (!isRepositoryExist) {
        repositorieAutocompleteList.unshift(repositoryItem)
      }
    }
  }

  return repositorieAutocompleteList
}
